import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {SingleEditEnforcer, SingleEditTrackable} from '@webmate-web-core/shared/components/forms-commons/single-edit-enforcer.service';
import {faSave, faTimes} from '@fortawesome/pro-solid-svg-icons';
import {IconDefinition} from '@fortawesome/fontawesome-svg-core';
import {InputText} from 'primeng/inputtext';

@Component({
    selector: 'wm-editable-inlinetext',
    templateUrl: './editable-inlinetext.component.html',
    styleUrls: ['./editable-inlinetext.component.less'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: EditableInlineTextComponent
        }
    ]
})
/**
 * Display a line of text that can be edited in an editor on click.
 * (Like in Jira UI)
 */
export class EditableInlineTextComponent implements ControlValueAccessor, SingleEditTrackable {
    @Input() placeholder?: string;

    @Input() size: number = 20;

    @Input() saveIcon: IconDefinition = faSave;

    @Input() readonly = false;

    @Input() renderHtml: boolean = true;

    @ViewChild('contentInput', {read: InputText}) contentInput: InputText;

    @Output() onTextChange: EventEmitter<string> = new EventEmitter<string>();

    @Output() onSave: EventEmitter<string> = new EventEmitter<string>();

    content: string;
    oldContent: string;

    onChange = (content: string) => {}; // nop to prevent errors before init

    onTouched = () => {};

    touched = false;

    disabled = false;

    isEditing = false;

    constructor(private singleEditEnforcer: SingleEditEnforcer) {
        singleEditEnforcer.registerTrackable(this);
    }

    ngOnDestroy() {
        this.singleEditEnforcer.unregisterTrackable(this);
    }

    disableEdit() {
        this.isEditing = false;
    }


    save() {
        this.isEditing = false;
        this.onEditorChange();
        setTimeout(() => {
            this.onSave.emit(this.content);
        });
    }

    cancel() {
        this.content = `${this.oldContent}`;
        this.isEditing = false;
    }

    markAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }

    enableEditing() {
        if (this.readonly || this.disabled) {
            return;
        }

        // we only want one instance to be editing at a time
        this.singleEditEnforcer.disableAllExcept(this);
        this.oldContent = `${this.content}`;
        this.isEditing = true;
        setTimeout(() => {
            this.contentInput.el.nativeElement.focus();
        });
    }

    registerOnChange(onChange: any): void {
        this.onChange = onChange;
    }

    registerOnTouched(onTouched: any): void {
        this.onTouched = onTouched;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    writeValue(content: string): void {
        this.content = content;
    }

    onEditorChange() {
        setTimeout(() => {
            if (this.onChange) {
                this.onChange(this.content);
                this.onTextChange.emit(this.content);
            }
            if (this.onTouched) {
                this.onTouched();
            }
        });
    }

    protected readonly faSave = faSave;
    protected readonly faTimes = faTimes;
}

